import type { Modeling, ModelingApi } from '../../type';

export const MODELING_KEYS = {
  getCount: (param?: Partial<ModelingApi.GetCount.Request>) =>
    param
      ? (['modelingApi.getCount', param] as const)
      : (['modelingApi.getCount'] as const),
  getList: (filter?: Partial<ModelingApi.GetList.Request>) =>
    filter
      ? (['modelingApi.getList', filter] as const)
      : (['modelingApi.getList'] as const),
  getDetail: (id: Modeling['id']) => ['modelingApi.getDetail', id] as const,
  getPerformance: (id: Modeling['id']) =>
    ['modelingApi.getPerformance', id] as const,
};
